import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

import loadingGif from 'assets/images/ring.gif';

const ariaSupport = true;
const ariaAlt = 'loading animation';
const ariaLabel = 'loading, please wait.';
const ariaAssertive = false;

Vue.use(VueLazyload, {
  loading: loadingGif,
  attempt: 1,
  adapter: {
    loaded({ el }) {

      if(!el.getAttribute("data-loaded-failsafe")) {
        el.setAttribute("data-loaded-failsafe", true);

        let originalAttribute = el.getAttribute('data-org-alt');
        let originalAriaLabel = el.getAttribute('data-org-aria');

        //console.log("originalAttribute")

        if (originalAttribute) {
          el.setAttribute('alt', originalAttribute);
          el.removeAttribute('data-org-alt');
        } else {
          el.removeAttribute('alt');
        }

        if (originalAriaLabel) {
          el.setAttribute('aria-label', originalAriaLabel);
          el.removeAttribute('data-org-aria');
        } else {
          el.removeAttribute('aria-label');
        }

        el.setAttribute('aria-busy', 'false');
        el.setAttribute('aria-live', 'off');
        el.removeAttribute('data-first-time-loaded');

      }

    },
    loading(listener) {
      let el = listener.el;

      if (!el.getAttribute('data-first-time-loading')) {
        el.setAttribute('data-first-time-loading', true);

        let originalAttribute = el.getAttribute('alt');
        let originalAriaLabel = el.getAttribute('aria-label');

        if (ariaAlt) {
          el.setAttribute('alt', ariaAlt);
        }
        if (ariaLabel) {
          el.setAttribute('aria-label', ariaLabel);
        }
        if (originalAttribute) {
          el.setAttribute('data-org-alt', originalAttribute);
        }
        if (originalAriaLabel) {
          el.setAttribute('data-org-aria', originalAriaLabel);
        }

        if (ariaAssertive) {
          el.setAttribute('aria-busy', 'true');
          el.setAttribute('aria-live', 'assertive');
        } else {
          el.setAttribute('aria-busy', 'true');
          el.setAttribute('aria-live', 'polite');
        }
      }
    },
  }
});